module.exports = __webpack_public_path__ + "static/img/more_active.17607690.svg";